<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import PrintOptions from "@/components/modals/print-options.vue";
import ApiResourceLogs from "@/components/modals/api-resource-logs.vue";
import Swal from "sweetalert2";
import { required } from "vuelidate/lib/validators";
import ResourceUpdate from "@/router/views/office/office-widgets/actual-resource-item.vue";
import RawData from "@/components/widgets/raw-data.vue";

export default {
    page: {
        title: "List of Resources",
    },
    components: {
        Layout,
        PageHeader,
        PrintOptions,
        ApiResourceLogs,
        ResourceUpdate,
        RawData
    },
    data() {
        return {
            title: "Resources",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Resources",
                    active: true,
                },
            ],
            tableData: [],
            searchData: [],
            modalTitle: "",
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: "",
            filterOn: [],
            sortBy: "",
            sortDesc: false,
            indexSelected: -1,
            tableBusy: false,
            searchHit: false,
            itemSelected: null,
            totalProcurables: 0,
            procurableCount: 0,
            form: {
                id: "",
                remarks: "",
            },
            selectedApiId: 0,
        };
    },
    validations: {
        form: { remarks: { required } },
    },
    computed: {
        rows(){
            let data = this.tableData;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return data.length;
        },
        filtered(){
            let data = this.tableData;
            var total = this.currentPage * this.perPage;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPage, total);
            if (this.currentPage > 1 && currentData.length == 0) {
                total = (this.currentPage - 1) * this.perPage;
                currentData = data.slice(total - this.perPage, total);
            }
            return currentData;
        },
        selectedItems(){
            let items = [];
            this.tableData.forEach(x => {
                x.apiResources.forEach(y => {
                    if(y.selected){
                        items.push(y);
                    }
                });
            });
            return items;
        }
    },
    async created() {
        this.totalRows = this.items.length;
        this.getInitialItems(this.$store.state.data.cycle, this.$store.state.data.selectedDU.id);
    },
    methods: {
        async changeCycle(cycle) {
            this.getInitialItems(cycle, this.$store.state.data.selectedDU.id);
        },
        async changeDU(deliveryUnitId) {
            this.getInitialItems(this.$store.state.data.cycle, deliveryUnitId);
        },
        onFiltered(filteredSuppliers) {
            this.totalRows = filteredSuppliers.length;
            this.currentPage = 1;
        },
        getInitialItems(cycle, deliveryUnitId) {
            this.tableData = [];
            this.tableBusy = true;
            this.$store
                .dispatch("apiresource/GetAllResourcesByDUSimplified", {
                    cycle,  
                    deliveryUnitId
                })
                .then(async (res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, 'error');
                    }
                    res.data.forEach(x => {
                        x.filterKey = `${x.apiNumber} ${x.name}`;
                        x.apiResources.forEach(y => {
                            y.filterKey = `${y.itemName} ${y.description}`;
                            x.filterKey += ` ${y.itemName} ${y.description}`;
                            y.selected = false;
                            x.selectAll = false;
                        });
                    });
                    this.tableData = res.data;
                    this.tableBusy = false;
                })
                .catch((err) => {
                    this.tableBusy = false;
                    this.showToast("Something went wrong", "error");
                });
        },
        searchProcurable() {
            this.tableBusy = true;
            this.searchHit = true;
            var data = this.tableData.filter((item) => {
                return item.searchList
                    .toUpperCase()
                    .includes(this.filter.toUpperCase());
            });
            this.searchData = data;
        },
        returnData() {
            if (!this.filter) {
                this.searchHit = false;
            }
        },
        allowPR(row) {
            Swal.fire({
                title: "Are you sure?",
                text: "You want to allow PR without consolidation?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, allow it!",
            }).then(async (result) => {
                if (result.value) {
                    row.prLoading = true;
                    this.$store
                        .dispatch("apiresource/AllowPRMultiple", [row.id])
                        .then((res) => {
                            setTimeout(() => {
                                row.prLoading = false;
                                row.allowPr =
                                    !row.allowPr;
                            }, 500);
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        printAPPByCampus(){
            this.$refs.printOpt.putOptions({apiUrl: 'api/Report/Procurement/APP/Campus', routeVariables: [this.$store.state.data.cycle]})
            this.$bvModal.show('print-options-modal')
        },
        allowAllPR(row){
            let ids = [];
            row.apiResources.forEach(x => {
                ids.push(x.id);
            });
            Swal.fire({
                title: "Are you sure?",
                text: "You want to allow all items PR without consolidation?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, allow it!",
            }).then(async (result) => {
                if (result.value) {
                    row.apiResources.forEach(x => x.prLoading = true);
                    this.$store
                        .dispatch("apiresource/AllowPRMultiple", ids)
                        .then((res) => {
                            setTimeout(() => {
                                row.apiResources.forEach(x => {
                                    x.allowPr = true
                                    x.prLoading = false;
                                });
                            }, 500);
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        async approveItem(array) {
            Swal.fire({
                title: "Are you sure?",
                text: `You want approve this ${array.length > 1 ? 'items' : 'item'} for technical review?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, allow it!",
            }).then(async (result) => {
                if (result.value) {
                    let error = false;
                    for await (const x of array) {
                        try{
                            const { data : res } = await this.$store.dispatch("responsibilitycenter/ApproveTechnical", x.id);
                            if (res.error) {
                                error = true;
                            }
                            x.technicalReviewStatus = "APPROVED";
                        }catch(err) {
                            error = true;
                        }
                    }
                    if (error) {
                        return this.showToast('Something went wrong!', 'error');
                    }
                    this.showToast('Successfully approved', 'success');
                }
            });
        },
        returnItem(array) {
            let modifiedItems = [];
            array.forEach(x => {
                let isModified = parseFloat(x.totalQuantity) - parseFloat(x.remainingQuantity) > 1;
                if(isModified){
                    modifiedItems.push(x);
                }
            });
            if(modifiedItems.length > 0){
                this.showToast(`Item ${modifiedItems[0].itemName} was modified. Cannot proceed.`, 'warning');
                return;
            }
            this.itemSelected = array;
            this.form.id = 0;
            this.form.remarks = "";
            this.$bvModal.show("return-modal");
        },
        async returnSubmit() {
            let error = false;
            for await (const x of this.itemSelected) {
               try{
                    const { data : res } = await this.$store.dispatch("responsibilitycenter/ReturnTechnical", {
                        id: x.id,
                        remarks: this.form.remarks
                    });
                    if (res.error) {
                        return this.showToast(res.data.errorMessage, 'warning');
                    }
                    x.technicalReviewStatus = "RETURN";
               } catch(err) {
                    error = true;
               }
            }
            if (error) {
                return this.showToast('Something went wrong!', 'error');
            }
            this.$bvModal.hide("return-modal");
            this.showToast('Successfully returned', 'success');
        },
        async returnTechRep(array) {
            let error = false;
            Swal.fire({
                title: "Are you sure?",
                text: `You want to return this ${array.length > 1 ? 'items' : 'item'} to technical review?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, return it!",
            }).then(async (result) => {
                if (result.value) {
                    for (const x of array) {
                        try{
                            const { data : response } = await this.$store.dispatch("apiresource/ResetToTechRep", x.id);
                            if (response.error) {
                                error = true;
                            }
                            x.technicalReviewStatus = "PENDING";
                        } catch (err) {
                            error = true;
                        }
                    }
                    if (error) {
                        return this.showToast('Something went wrong!', 'error');
                    }
                    this.showToast('Successfully returned to technical review', 'success');
                }
            });
        },
        closeUpdateModal(data){
            let index = this.tableData.findIndex(x => x.id == data.id);
            this.tableData[index].totalQuantity = data.quantity;
            this.tableData[index].totalWithInflation = data.amount;
        },
        successUpdateResource(data){
            data.filterKey = `${data.itemName} ${data.description}`;
            let index = this.tableData.findIndex(x => x.id == data.id);
            this.tableData.splice(index, 1, data);
        },
        updateItemColumn(data){
            if(data.type === 'deduct'){
                this.tableData.find((e) => e.id == data.id)[data.column] -= data.value;
            }else if(data.type === 'add'){
                this.tableData.find((e) => e.id == data.id)[data.column] += data.value;
            }else{
                this.tableData.find((e) => e.id == data.id)[data.column] = data.value;
            }
        },
        async updateResourceItem(props, type = "edit") {
            this.pageLoader(true);
            this.selectedApiId = props.apiId;
            await this.$refs['resource-update'].getAllBudgets(props.apiId);
            await this.$refs['resource-update'].getItemInfo(props, type);
            this.pageLoader(false);
        },
        filterResources(row){
            let data = row;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return data;
        },
        selectApi(row){
            row.apiResources.forEach(x => {
                x.selected = row.selectAll;
            });
        },
        selectItem(item, api, type = 'checkbox'){
            if(type === 'span'){
                item.selected = !item.selected;
            }
            if(!item.selected){
                api.selectAll = false;
            }else{
                let selectedCount = api.apiResources.filter(x => x.selected).length;
                if(selectedCount == api.apiResources.length){
                    api.selectAll = true;
                }else{
                    api.selectAll = false;
                }
            }
        },
        viewLogs({ id }) {
            this.$refs.itemlog.getData(id);
            this.$bvModal.show("api-resoure-log-modal");
        },
    },
};
</script>

<template>
    <Layout @changeCycle="changeCycle" @changeDU="changeDU($event.id)">
        <PageHeader :title="title" :items="items" />
        <b-modal
            id="return-modal"
            title="Return Remarks"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form @submit.prevent="returnSubmit" class="needs-validation">
                <b-row>
                    <b-col>
                        <div class="mb-3">
                            <label for="description">Remarks </label>
                            <textarea
                                id="description"
                                rows="3"
                                v-model="form.remarks"
                                placeholder="Enter Remarks..."
                                class="form-control"
                                :class="{
                                    'is-invalid':
                                        submitted && $v.form.remarks.$error,
                                }"
                            ></textarea>
                            <div
                                v-if="submitted && $v.form.remarks.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.form.remarks.required"
                                    >This value is required.</span
                                >
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Return Resource Item
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('return-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <ResourceUpdate 
            ref="resource-update" 
            :budgetTransferModal="true"
            :updatableMixOption="true"
            :selectedApiId="selectedApiId"
            @close-update="closeUpdateModal" 
            @update-item="successUpdateResource" 
            @specific-item-update="updateItemColumn"
            @refresh-all="getInitialItems($store.state.data.cycle, $store.state.data.selectedDU.id)"
        />
        <div class="mb-2">
            <div class="d-flex justify-content-between">
                <label
                    class="d-inline-flex align-items-center mb-0 me-1"
                >
                    <b-form-input
                        autocomplete="off"
                        v-model.lazy="filter"
                        type="search"
                        placeholder="Search API/Item Name..."
                        class="form-control"
                        style="width: 300px;"
                    ></b-form-input>
                     <b-form-select
                        class="form-select ms-1 w-25"
                        v-model="perPage"
                        :options="pageOptions"
                    ></b-form-select>
                </label>
                <div v-if="selectedItems.length">
                    <b-button variant="success" @click="approveItem(selectedItems)">Approve Technical Review ({{ selectedItems.length }})</b-button>
                    <b-button variant="warning" class="ms-1" @click="returnItem(selectedItems)">Return to Delivery Unit ({{ selectedItems.length }})</b-button>
                    <b-button variant="warning" class="ms-1" @click="returnTechRep(selectedItems)">Return to Technical Review ({{ selectedItems.length }})</b-button>
                </div>
            </div>
        </div>
        <div v-if="tableBusy">
            <h3>Loading...</h3>
        </div>
        <div v-if="tableData.length == 0 && !tableBusy">
            <h3>No data found...</h3>
        </div>
        <div v-if="!tableBusy && tableData.length > 0">
            <div v-for="y in filtered" :key="y.id">
                <div class="mb-2 d-flex">
                    <div
                        class="
                            form-check
                            form-checkbox-outline
                            form-check-success
                            mb-0
                        "
                    >
                        <input
                            type="checkbox"
                            :id="`customCheckApi-${y.id}`"
                            class="form-check-input"
                            v-model="y.selectAll"
                            @change="selectApi(y)"
                        />
                        <label :for="`customCheckApi-${y.id}`" class="d-inline"><span class="text-warning me-1">{{y.apiNumber}}</span> - <h5 class="mb-0 d-inline">{{y.name}}</h5></label>
                    </div>
                </div>
                <div class="d-flex align-items-center" v-for="x in filterResources(y.apiResources)" :key="`resourceList-z${x.id}`">
                    <span v-if="x.mixParentId > 0"><i class="bx bx-right-arrow-alt"></i></span>
                    <div class="mb-2 ms-3 p-3 broken-border position-relative w-100" :class="{'ms-2': x.mixParentId > 0}" >
                        <RawData 
                            :data="x" 
                            v-if="$store.state.decrypt.isAdmin()" 
                            placement="left"
                            :keyId="`A${y.id}B${x.id}`"
                        />
                        <div class="d-flex align-items-center justify-content-between" :key="`A${y.id}B${x.id}`">
                            <div>
                                <div class="d-flex">
                                    <div>
                                        <div class="d-flex align-items-center">
                                            <div class="font-size-20 text-yellow no-wrap">
                                                {{x.totalQuantity}} {{x.unit}}
                                            </div>
                                            <i class="bx bx-x font-size-20 me-2 text-yellow"></i>
                                        </div>
                                        <small v-if="parseFloat(x.totalQuantity) - parseFloat(x.remainingQuantity) > 1" class="text-danger">
                                            ({{parseFloat(x.totalQuantity) - parseFloat(x.remainingQuantity)}}) modified
                                        </small>
                                    </div>
                                    <div>
                                        <div>
                                            <div class="d-flex gap-1">
                                                <span @click="selectItem(x, y, 'span')" class="cursor-pointer">{{x.itemName}}</span>
                                                <div
                                                    class="
                                                        form-check
                                                        form-checkbox-outline
                                                        form-check-success
                                                        mb-0
                                                    "
                                                >
                                                    <input
                                                        type="checkbox"
                                                        :id="`customCheck-${x.id}`"
                                                        class="form-check-input"
                                                        v-model="x.selected"
                                                        @change="selectItem(x, y)"
                                                    />
                                                </div>
                                            </div>
                                            <div>
                                                <small>{{x.description}}</small>
                                                <small>
                                                    <span class="text-warning ms-1">[{{x.isProcurable ? 'Procurable' : 'Non-procurable'}}]</span>
                                                    <span class="text-warning ms-1" v-if="x.isMixed">[Mixed]</span>
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="
                                        d-flex mt-2
                                    "
                                >
                                    <b-dropdown
                                        id="dropdown-dropleft"
                                        right
                                        variant="secondary btn-sm"
                                        toggle-class="text-decoration-none"
                                        no-caret
                                    >
                                        <template #button-content>
                                            Actions <i class="bx bx-chevron-down"></i>
                                        </template>
                                        <b-dropdown-item
                                            @click="returnTechRep([x])"
                                            variant="warning"
                                            ><i
                                                class="
                                                    bx bx-log-out-circle me-1
                                                "
                                            ></i
                                            >Return to Technical Review</b-dropdown-item
                                        >
                                        <b-dropdown-item
                                            @click="returnItem([x])"
                                            variant="warning"
                                            ><i
                                                class="
                                                    bx bx-log-out-circle me-1
                                                "
                                            ></i
                                            >Return to Delivery Unit</b-dropdown-item
                                        >
                                        <b-dropdown-item
                                            @click="approveItem([x])"
                                            variant="green"
                                            ><i
                                                class="
                                                    bx bx-check
                                                "
                                            ></i
                                            >Approve Technical Review</b-dropdown-item
                                        >
                                        <b-dropdown-item
                                            @click="
                                                updateResourceItem(
                                                    x
                                                )
                                            "
                                            variant="dark"
                                            ><i
                                                class="
                                                    bx
                                                    bx-edit
                                                    font-size-18
                                                    me-1
                                                "
                                            ></i
                                            >Edit</b-dropdown-item
                                        >
                                        <b-dropdown-item
                                            @click="viewLogs(x)"
                                            variant="dark"
                                        >
                                            <i class="bx bx-receipt font-size-18 me-1"></i>
                                            View Logs
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </div>
                            </div>
                            <div class="text-center">
                                <div class="font-size-20 text-yellow mb-0">
                                    {{formatCurrency(x.totalWithInflation)}}
                                </div>
                                <div>
                                    <small>
                                        ({{formatCurrency(x.unitCost)}})
                                    </small>
                                </div>
                                <div>
                                    <div
                                        v-if="
                                            x.technicalReviewStatus.toUpperCase() ===
                                            'APPROVED'
                                        "
                                        class="
                                            d-flex
                                            justify-content-end
                                        "
                                    >
                                        <small class="text-green"
                                            >This
                                            item was
                                            approved.</small
                                        >
                                    </div>
                                    <div
                                        v-else-if="
                                            x.technicalReviewStatus.toUpperCase() ===
                                            'RETURNED'"
                                        class="
                                            d-flex
                                            text-warning
                                        "
                                    >
                                        <small
                                            >This
                                            item was
                                            returned.
                                            Waiting
                                            for
                                            changes.</small
                                        >
                                    </div>
                                    <div v-else>
                                        <small
                                            >Item is for technical review.</small
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row my-3">
            <div class="col">
                <div
                    class="
                        dataTables_paginate
                        paging_simple_numbers
                        float-end
                    "
                >
                    <ul
                        class="
                            pagination pagination-rounded
                            mb-0
                        "
                    >
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                        ></b-pagination>
                    </ul>
                </div>
            </div>
        </div>
        <print-options ref="printOpt"></print-options>
        <api-resource-logs ref="itemlog"></api-resource-logs>
    </Layout>
</template>